import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String, title: String };

  share() {
    if (navigator.share) {
      navigator
        .share({
          title: this.titleValue,
          url: this.urlValue,
        })
        .catch(() => {
          this.copyToClipboard();
        });
    } else {
      this.copyToClipboard();
    }
  }

  copyToClipboard() {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(this.urlValue)
        .then(() => {
          // Consider using a toast notification or temporary status message instead
          alert("Your link has been copied to clipboard!");
        })
        .catch(() => {
          this.showFallbackMessage();
        });
    } else {
      this.showFallbackMessage();
    }
  }

  showFallbackMessage() {
    // Consider using a modal or toast instead of alert
    alert(`Please copy this link: ${this.urlValue}`);
  }
}
